import { render, staticRenderFns } from "./ConfirmBalanceTopUpButton.vue?vue&type=template&id=73c8630a&"
import script from "./ConfirmBalanceTopUpButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBalanceTopUpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardText,VFileInput,VForm,VSelect})
